import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ZTypography from '../components/ZTypography';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import logo from '../asset/images/zoi-fintech-services.png'
import ZGrid from '../components/ZGrid';
import ZAppBar from '../components/ZAppBar';
import { withStyles } from '@material-ui/core/styles';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Avatar from '@mui/material/Avatar';
import { grey } from '@mui/material/colors';
import AccountBalanceSharpIcon from '@mui/icons-material/AccountBalanceSharp';
import TransformSharpIcon from '@mui/icons-material/TransformSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import { Redirect } from 'react-router';
import Dashboard from "../containers/Dashboard";
import FundTransfer from '../containers/FundTransfer';
import Transaction from '../containers/Transaction';
import { Switch, Route, BrowserRouter } from 'react-router-dom';

const drawerWidth = 240;

function ZNav(props) {
  const classes = props.classes
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const drawer = (
    <div>
      <Toolbar />
      <List>
        {['Accounts', 'Transfer', 'Logout',].map((text, index) => (
          <ListItem button key={text} className={classes.listItem}>
            <ListItemIcon className={classes.listItemIcon}>
              {index == 0 ? <AccountBalanceSharpIcon /> : ''}
              {index == 1 ? <TransformSharpIcon /> : ''}
              {index == 2 ? <LogoutSharpIcon /> : ''}
            </ListItemIcon>
            <ListItemText primary={text} className={classes.listItemText} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;
  const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));
  return (

    <Box sx={{ display: 'flex' }}>
      <ZAppBar className={classes.appBar}
        position="fixed"
        sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
      >
        <Toolbar className={classes.toolBar}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <ZGrid item md={3}>
            <div className={classes.logo}>
              <div className={classes.logoContainer}>
                <img src={logo} />
                {/* <span className={classes.txtWelcome}>Zoi fintech services</span> */}
              </div>
            </div>
          </ZGrid>
          {/* <ZGrid item md={3}> */}
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search>
          {/* </ZGrid> */}
          <ZGrid item md={5}></ZGrid>
          <ZGrid item md={2} className={classes.avatar}>
            <Avatar sx={{ bgcolor: grey[50], color: "#303778" }}>J</Avatar>
          </ZGrid>
        </Toolbar>
      </ZAppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: "#f8f9fa" },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer className={classes.menuContent}
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, },
          }}
          open
        >
          {drawer}
          {/* <Fragment>
            <main id="mainContent">
              <section>

              </section>
            </main>
          </Fragment> */}
        </Drawer>
      </Box>

      <Box className={classes.rightContent}
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
       
          <Dashboard/>
        {/* <Switch>
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/fundTransfer" component={FundTransfer} />
        </Switch> */}
      </Box>
    </Box>
  );
}

const styles = (theme) => ({
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 100,
    // backgroundColor: "#fff",
    backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    // boxShadow:'none'
    boxShadow: '0px 0px 0px 0.5px rgb(0 0 0 / 9%)',
    backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    margin: "0px !important",
    '& .MuiToolbar-root': {
      padding: 0,
      minHeight: 90
    }
  },

  dflex: {
    display: "flex",
    '& .MuiButton-root': {
      marginTop: "12px !important"
    }
  },
  GridContainer: {
    minHeight: 90
  },



  userWelcome: {
    display: "flex",
    alignItems: "center",
    marginLeft: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529"
  },

  cardHeader: {
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529",
    marginBottom: 20
  },

  cardSubHeader: {
    textTransform: "uppercase",
    color: "#212529",
    fontSize: 14,
    padding: "20px 0px 10px 0px",
    fontWeight: 600
  },

  cardContent: { minHeight: 60 },

  avatar: {
    justifyContent: "flex-end",
    display: "flex",
    marginRight: 15
  },

  profileCard: {
    boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%) !important",
    borderRadius: "0.75rem !important"
  },

  listItemIcon: {
    '& .MuiSvgIcon-root': {
      fill: "#303778",
      display: "flex",
      alignItems: "center",
      width: "1.5em",
      height: "1.5em",
      background: "#303778",
      fill: "#fff",
      borderRadius: "0.5rem",
      padding: 5,
      boxShadow: "0 0.25rem 0.375rem -0.0625rem rgb(20 20 20 / 12%), 0 0.125rem 0.25rem -0.0625rem rgb(20 20 20 / 7%) !important"
    }
  },

  listItemText: {
    '&:hover': {
      '& span.MuiTypography-root': {
        fontWeight: 600,
      }
    },

    '& span.MuiTypography-root': {
      color:"#92278F",
      fontWeight: 400,
      fontFamily: 'Noto Sans '
    }
  },

  listItem: {
    paddingRight: 0,
    '&:hover': {
      paddingRight: 0,
      borderRadius: "0.75rem",

      '& div.listItemText': {
        '& span.MuiTypography-root': {
          fontWeight: 600,
        }
      },

      '& listItemIcon': {
        '& svg.MuiSvgIcon-root': {
          background: "#303778",
          fill: "#fff",
          borderRadius: "0.5rem",
          padding: 5,
        }
      }
    },
  },

  menuContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    },

    '& .MuiPaper-root': {
      borderRight: "none",
      // background:"#f8f9fa !important"
    }
  },

  rightContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    }
  },

  logo: {
    margin: "20px !important",
    margin: "0px !important"
  },

  logoContainer: {
    background: "#fff", margin: 15, display: "flex",
    alignItems: "center",
    padding: "0px 10px"
  },


  txtWelcome: {
    fontWeight: 600,
    fontSize: 16,
    margin: 15,
    textTransform: "uppercase",
    fontFamily: "Noto Sans ",
    color: "#000000"
  },
})

export default withStyles(styles)(ZNav);


